{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Szablony WhatsApp",
      "SUBTITLE": "Wybierz szablon WhatsApp, który chcesz wysłać",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Wyszukaj szablony",
      "NO_TEMPLATES_FOUND": "Nie znaleziono szablonów dla",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Kategoria",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Język",
        "TEMPLATE_BODY": "Treść szablonu",
        "CATEGORY": "Kategoria"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Zmienne",
      "LANGUAGE": "Język",
      "CATEGORY": "Kategoria",
      "VARIABLE_PLACEHOLDER": "Wprowadź wartość {variable}",
      "GO_BACK_LABEL": "Powrót",
      "SEND_MESSAGE_LABEL": "Wyślij wiadomość",
      "FORM_ERROR_MESSAGE": "Proszę wypełnić wszystkie zmienne przed wysłaniem",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
